import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=5f1200a0&scoped=true"
import script from "./InformationForm.vue?vue&type=script&lang=js"
export * from "./InformationForm.vue?vue&type=script&lang=js"
import style0 from "./InformationForm.vue?vue&type=style&index=0&id=5f1200a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1200a0",
  null
  
)

export default component.exports